import { UntypedFormGroup, AbstractControl, UntypedFormArray } from '@angular/forms';

export function markAsDirty(group: UntypedFormGroup | UntypedFormArray): void {
  (Object as any).values(group.controls).forEach((control) => {
    if (control.controls) {
      markAsDirty(control);
    }

    (control as AbstractControl).markAsDirty();
  });
}

export function resetFormState(formGroup: UntypedFormGroup): void {
  (Object as any).values(formGroup.controls).forEach((control) => {
    (control as AbstractControl).markAsUntouched();
    (control as AbstractControl).markAsPristine();

    if (control.controls) {
      resetFormState(control);
    }
  });
}

export function updateValidity(group: UntypedFormGroup | UntypedFormArray): void {
  (Object as any).values(group.controls).forEach((control) => {
    if (control.controls) {
      updateValidity(control);
    }

    (control as AbstractControl).updateValueAndValidity({
      onlySelf: true,
      emitEvent: false
    });
  });
}

export function updateValueAndValidity(control: AbstractControl): void {
  if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
    Object.values(control.controls).forEach((x) => updateValueAndValidity(x));
  }

  control.updateValueAndValidity({
    emitEvent: false,
    onlySelf: true
  });
}

export const concatFormNameWithNumber = (formName: string, instanceNumber: string) => {
  return instanceNumber ? `${formName} #${instanceNumber}` : formName;
};
